// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PresignUploadType } from './presign-upload-type';
import {
    PresignUploadTypeFromJSON,
    PresignUploadTypeFromJSONTyped,
    PresignUploadTypeToJSON,
    PresignUploadTypeToJSONTyped,
} from './presign-upload-type';

/**
 * 
 * @export
 * @interface PresignUploadRequest
 */
export interface PresignUploadRequest {
    /**
     * 
     * @type {string}
     * @memberof PresignUploadRequest
     */
    file_name: string;
    /**
     * 
     * @type {PresignUploadType}
     * @memberof PresignUploadRequest
     */
    upload_type: PresignUploadType;
    /**
     * 
     * @type {string}
     * @memberof PresignUploadRequest
     */
    vendor_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PresignUploadRequest
     */
    vendor_name?: string;
}



/**
 * Check if a given object implements the PresignUploadRequest interface.
 */
export function instanceOfPresignUploadRequest(value: object): value is PresignUploadRequest {
    if (!('file_name' in value) || value['file_name'] === undefined) return false;
    if (!('upload_type' in value) || value['upload_type'] === undefined) return false;
    return true;
}

export function PresignUploadRequestFromJSON(json: any): PresignUploadRequest {
    return PresignUploadRequestFromJSONTyped(json, false);
}

export function PresignUploadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresignUploadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'file_name': json['file_name'],
        'upload_type': PresignUploadTypeFromJSON(json['upload_type']),
        'vendor_id': json['vendor_id'] == null ? undefined : json['vendor_id'],
        'vendor_name': json['vendor_name'] == null ? undefined : json['vendor_name'],
    };
}

export function PresignUploadRequestToJSON(json: any): PresignUploadRequest {
    return PresignUploadRequestToJSONTyped(json, false);
}

export function PresignUploadRequestToJSONTyped(value?: PresignUploadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file_name': value['file_name'],
        'upload_type': PresignUploadTypeToJSON(value['upload_type']),
        'vendor_id': value['vendor_id'],
        'vendor_name': value['vendor_name'],
    };
}
